import { Button, Divider, Stack, Typography } from "@mui/material";
import type { CurrencyDimensionMeta } from "../../../../../../api/types/svTypes.ts";
import FormatSelect from "../../../sv/components/builder/common/FormatSelect.tsx";
import { DimensionNames } from "../../../sv/utilities/DimensionNames.ts";
import useAgingSummaryContext from "../contexts/AgingSummaryContext.tsx";

const currencyDimensions: CurrencyDimensionMeta[] = [
  { name: DimensionNames.EntityCurrencyCode, caption: "Entity Currency Code" },
];

const AgingSummarySettingsPanel = () => {
  const { numberFormat, onNumberFormatChange, isSettingsDefault, onResetSettings } = useAgingSummaryContext();

  return (
    <Stack spacing={2} sx={{ width: 300 }}>
      <Stack direction="row" sx={{ alignItems: "center", justifyContent: "space-between" }}>
        <Typography variant="h6" sx={{ fontWeight: 600 }}>
          Settings
        </Typography>
        <Button
          variant="text"
          size="small"
          color="secondary"
          disabled={isSettingsDefault}
          onClick={onResetSettings}
          sx={{ textTransform: "none" }}
        >
          Reset All
        </Button>
      </Stack>
      <Stack spacing={1.5} sx={{ flex: 1 }}>
        <Stack spacing={1} direction="row" sx={{ alignItems: "center", flex: 1, width: "100%" }}>
          <Typography variant="body1" sx={{ whiteSpace: "nowrap", width: "100px" }}>
            Number Format
          </Typography>
          <FormatSelect
            format={numberFormat}
            onUpdateFormatter={onNumberFormatChange}
            currencyDimensions={currencyDimensions}
            disabled={false}
          />
        </Stack>
        <Divider sx={{ borderStyle: "dashed" }} />
      </Stack>
    </Stack>
  );
};

export default AgingSummarySettingsPanel;
